var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:globe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M89.3913 15.4001C48.3201 15.4001 15.0273 48.6929 15.0273 89.7641C15.0273 130.835 48.3201 164.128 89.3913 164.128C130.463 164.128 163.755 130.835 163.755 89.7641C163.755 48.6929 130.463 15.4001 89.3913 15.4001ZM89.3913 149.255L104.264 134.383L111.701 126.946V112.073H96.8277V104.637L89.3913 97.2005H67.0821V119.51L81.9549 134.383V148.742C52.6555 145.061 29.9001 120.045 29.9001 89.7641L37.3365 97.2005H52.2093V82.3277H67.0821L89.3913 60.0185V45.1457H74.5185L67.0821 37.7093V34.653C81.3833 28.8212 97.3994 28.8212 111.701 34.653V45.1457L104.264 52.5821V67.4549L111.701 74.8913L134.976 51.6154C140.639 58.3894 144.719 66.3411 146.919 74.8913H134.01L119.137 89.7641V104.637L126.573 112.073H141.446L143.573 114.2C134.225 134.836 113.478 149.255 89.3913 149.255Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.bb12e624028c03cf341b60c83b96b065.svg";
export { ForwardRef as ReactComponent };